<template>
  <div class="line-container">
    <span class="tx-30 tx-bold" :style="'color:'+getColorForValue(value)"> {{ (decimal === undefined) ?value.toFixed((value<100)?fractionalLength():0) :(decimal) ?value.toFixed(fractionalLength()) :value.toFixed(0) }} </span>
    <span class="tx-14" style="color: #999"> {{ " " + unit }}</span>
    <div :ref="entityId" class="line" autoresize></div>
  </div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: 'VueLine',
  props: {
    entityId: { type: String, default: Math.floor(100000000 + Math.random() * 900000000).toString() },
    value: { type: Number, required: true },
    unit: { type: String, default: 'u' },
    min: { type: Number, default: 0 },
    max: { type: Number, default: 100 },
    sectors: { type: Array, default: () => [20, 40, 60, 80] },
    decimal: { type: Boolean, default: undefined }
  },
  data() {
    return {
      chart: null,
      colors: ["#8f060f", "#ff9900", "#05b80b", "#ff9900", "#8f060f"]
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeUnmount() {
    if (this.chart) {
      this.chart.dispose();
      this.chart = null;
    }
  },
  watch: {
    value() { this.updateChart(); },
    min() { this.initChart(true); },
    max() { this.initChart(true); },
    unit() { this.initChart(true); }
  },
  methods: {
    fractionalLength() {
      return (localStorage.getItem("ClomosFractionalLength") != undefined) ? localStorage.getItem("ClomosFractionalLength") : 2;
    },
    getColorForValue(value) {
      for (let i = 0; i < this.sectors.length; i++) {
        const lower = i === 0 ? this.min : this.sectors[i - 1];
        const upper = this.sectors[i];
        if ((value-1) >= lower && (value-1) <= upper) return this.colors[i];
      }
      return this.colors[this.colors.length - 1];
    },
    buildOption() {
      const min = this.min;
      const max = this.max;
      const value = this.value;

      let o = {
        xAxis: {
          min,
          max,
          type: 'value',
          axisLine: { show: true ,
            lineStyle: {
              width: 1,
              color: '#fff'
            }
          },
          axisTick: { show: true },
          axisLabel: { color: '#fff' }
        },
        yAxis: {
          type: 'category',
          data: [''],
          axisLine: { show: false },
          axisTick: { show: false }
        },

        grid: { left: 15, right: 15, top: 0, bottom: 42 },

        series: [
          {
            type: 'bar',
            data: [value],
            barWidth: 15,
            itemStyle: {
              color: (props) => {return this.getColorForValue(props.value)},
              borderRadius: 0
            },
            label: {
              show: true,
              position: 'top',
              //formatter: (params) => {return `${params.value} ${this.unit}`},
              formatter: () => {return ""},
              color: '#fff',
              fontWeight: 'bold',
              offset: [0, 5]
            }
          },
          {
            type: 'bar',
            data: [...this.sectors].reverse(),
            barWidth: 5,
            itemStyle: {
              color: (params) => {return this.getColorForValue(params.value)},
              borderRadius: 0
            },
            label: {
              show: true,
              position: 'top',
              //formatter: (params) => {return `${params.value} ${this.unit}`},
              formatter: () => {return ""},
              color: '#fff',
              fontWeight: 'bold',
              offset: [0, 5]
            }
          }
        ]
      };
      return o;
    },
    updateChart() {
      if (!this.chart) return;
      this.chart.setOption(
        {
          series: [
            { data: [this.value] }
          ]
        },
        false
      );
    },
    initChart() {
      if (this.chart) {
        this.chart.dispose();
        this.chart = null;
      }
      if (!this.chart) {
        const lrl = this.$refs[this.entityId];
        if (!lrl) return;
        this.chart = echarts.init(lrl);
      }
      this.chart.clear();
      this.chart.setOption(this.buildOption(), true);
    }
  }
};
</script>

<style scoped>
.line-container {
  width: 100%;
  height: 120px;
  padding: 0;
  margin: 0;
}
.line {
  width: 100%;
  height: 50%;
  margin: auto;
}
</style>